import { render, staticRenderFns } from "./TaskMonitorPathology.vue?vue&type=template&id=0a20c1c5&scoped=true"
import script from "./TaskMonitorPathology.vue?vue&type=script&lang=js"
export * from "./TaskMonitorPathology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20c1c5",
  null
  
)

export default component.exports